// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2Upw1","title":"Info_title__1I4wy","links":"Info_links__1KyHu","link":"Info_link__glPFX","logo":"Info_logo__24e2f"};